import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const AnalyzerList = ({ leakCoupons }) => {
    return (
        <Table striped>
            <thead>
                <tr>
                    <th style={{ width: '5%' }}>ID</th>
                    <th style={{ width: '10%' }}>Website</th>
                    <th style={{ width: '25%' }}>Links</th>
                    <th style={{ width: '25%' }}>Number of Coupons</th>
                </tr>
            </thead>
            <tbody>
                {leakCoupons?.length > 0 && leakCoupons?.map(({ website, links, numberOfCoupons }, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{website}</td>
                        <td>{links}</td>
                        <td>{numberOfCoupons}</td>
                    </tr>
                ))}
                {
                    leakCoupons?.length === 0 && (
                        <tr>
                            <td colSpan="5" className="text-center">No leak coupons found</td>
                        </tr>
                    )
                }
            </tbody>
        </Table>
    );
};

AnalyzerList.propTypes = {
    leakCoupons: PropTypes.array.isRequired,
};

export default AnalyzerList;